import React from 'react';
import { theme } from '../styles/theme';

// Campi descrittivi di un evento privato (tutti facoltativi), usati in creazione e in modifica
export const PRIVATE_FIELD_DEFS = [
  { key: 'contactName', label: 'Referente', placeholder: 'Nome del referente' },
  { key: 'contactPhone', label: 'Telefono referente', placeholder: '+39 ...', type: 'tel' },
  { key: 'duration', label: 'Durata', placeholder: "es. un'ora e mezza circa" },
  { key: 'where', label: 'Dove', placeholder: 'Luogo o indirizzo' },
  { key: 'participants', label: 'N° persone', placeholder: 'es. 11', type: 'number' },
  { key: 'ceramics', label: 'Ceramiche', placeholder: 'es. piatti + 1 caraffa' },
  { key: 'cost', label: 'Costo', placeholder: 'es. 55€ a persona + pernottamento' },
  { key: 'paymentMethod', label: 'Metodo di pagamento', placeholder: "es. contanti il giorno dell'evento o bonifico anticipato" },
];

export const EMPTY_PRIVATE_FIELDS = PRIVATE_FIELD_DEFS.reduce((acc, f) => ({ ...acc, [f.key]: '' }), {});

// Estrae dai dati evento i valori dei campi privati come stringhe (per popolare il form)
export const privateFieldsFromEvent = (event) =>
  PRIVATE_FIELD_DEFS.reduce((acc, f) => {
    const v = event[f.key];
    return { ...acc, [f.key]: v === null || v === undefined ? '' : String(v) };
  }, {});

function PrivateEventFields({ values, onChange }) {
  return (
    <>
      {PRIVATE_FIELD_DEFS.map((f) => (
        <label key={f.key} style={styles.label}>
          {f.label}
          <input
            type={f.type || 'text'}
            min={f.type === 'number' ? 0 : undefined}
            value={values[f.key] || ''}
            onChange={(e) => onChange(f.key, e.target.value)}
            placeholder={f.placeholder}
            style={styles.input}
          />
        </label>
      ))}
    </>
  );
}

export const fieldStyles = {
  label: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    fontSize: '14px',
    color: theme.colors.text,
    fontWeight: 'bold',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    fontWeight: 'normal',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    width: '100%',
  },
  textarea: {
    padding: '10px',
    fontSize: '16px',
    border: `1px solid ${theme.colors.border}`,
    borderRadius: '4px',
    fontWeight: 'normal',
    fontFamily: 'inherit',
    resize: 'vertical',
    boxSizing: 'border-box',
    width: '100%',
  },
  error: {
    color: 'red',
    fontSize: '12px',
    fontWeight: 'normal',
  },
};
const styles = fieldStyles;

export default PrivateEventFields;
